import React, { useState, useEffect, useContext } from 'react';
import AdminContext from '../../../StateContext/Application';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
const BudgetEstimationList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext);
    const { GetAllBudgetEstimationList } = context;
    const [budgetEstimation, setBudgetEstimationList] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const [selectYear, setSelectYear] = useState('');
    const [selectAmount, setSelectAmount] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getBudgetEstimationList = async () => {
        let data = await GetAllBudgetEstimationList();
        console.log("data", data);
        setBudgetEstimationList(data);
        setFilteredBills(data);
    };
    const headerStyle = {
        padding: "12px 16px",
        whiteSpace: "nowrap",
        borderRight: "1px solid #e0e0e0",
        textTransform: "capitalize",
    }
    useEffect(() => {
        getBudgetEstimationList();
    }, []);
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = budgetEstimation.filter(bill =>
            (!selectYear || bill.Year === selectYear) &&
            (!selectAmount || bill.EsitmateAmount === selectAmount) &&
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, selectYear, selectAmount, budgetEstimation]);
    const uniqueYear = [...new Set(budgetEstimation.map(item => item.Year))];
    const uniqueAmount = selectYear ? [...new Set(budgetEstimation.filter(item => item.Year === selectYear).map(item => item.EsitmateAmount))] : [];

    // return (
    //     <>
    //         <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-11 m-auto">
    //                 <div className="col-12">

    //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

    //                         <h5 className='my-auto fw-bold'>
    //                             <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                             <span className='my-auto'>Budget Estimation List</span>
    //                         </h5>

    //                         {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}
    //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                             <img
    //                                 src="/Search32.png"
    //                                 alt="Search Icon"
    //                                 style={{
    //                                     position: "absolute",
    //                                     top: "50%",
    //                                     left: "10px",
    //                                     transform: "translateY(-50%)",
    //                                     width: "16px",
    //                                     height: "16px",
    //                                     opacity: 0.6
    //                                 }}
    //                             />
    //                             <input
    //                                 type="text"
    //                                 placeholder="Search Here"
    //                                 onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                     border: "1px solid #ccc",
    //                                     borderRadius: "8px",
    //                                     backgroundColor: "#f1f6fc",
    //                                     fontSize: "14px",
    //                                     color: "#333",
    //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                     outline: "none"
    //                                 }}
    //                             />
    //                         </div>

    //                     </div>

    //                     <div className='col-12 pb-5'>
    //                         <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
    //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
    //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                     <thead>
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
    //                                             <th style={{ width: "5%" }}>Sr.No</th>
    //                                             <th style={headerStyle}>Approved Year</th>
    //                                             {/* <th style={headerStyle}>Budget ID</th> */}
    //                                             <th style={headerStyle}>Budget Head</th>
    //                                             <th style={headerStyle}>District</th>
    //                                             <th style={headerStyle}>Taluka</th>
    //                                             <th style={headerStyle}>Work Name</th>
    //                                             <th style={{ width: "15%" }}>Demand Amount</th>
    //                                             <th style={{ width: "15%" }}>Limit Allocated Amount</th>
    //                                             <th style={{ width: "15%" }}>Date</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         {currentBills?.length === 0 ? (
    //                                             <tr>
    //                                                 <td colSpan={10} style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
    //                                                     No data available
    //                                                 </td>
    //                                             </tr>
    //                                         ) : (currentBills?.map((budgetEstimation, index) => {
    //                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                             return (
    //                                                 <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>                                                        <td>{(currentPage - 1) * billsPerPage + index + 1}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.FinancialYear}</td>
    //                                                     {/* <td style={{ padding: '8px 8px' }}>{budgetEstimation.BudgetID}</td> */}
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.HeadCode}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.District}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.Taluka}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.ProposalID}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.DemandAmount}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{budgetEstimation.OriginalLimitAllocatedAmount}</td>
    //                                                     <td style={{ padding: '8px 8px' }}>{new Date(budgetEstimation.Date).toLocaleString()}</td>
    //                                                 </tr>
    //                                             );
    //                                         })
    //                                         )}
    //                                     </tbody>
    //                                 </table>
    //                             </div>

    //                             <div className="col-12 mt-3">
    //                                 <div className='row'>
    //                                     <div className='col-6'>
    //                                         <p className="text-gray-600" style={{ fontSize: "14px" }}>
    //                                             Showing {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0} to {Math.min(indexOfLastBill, filteredBills.length)} of {budgetEstimation.length} entries
    //                                         </p>
    //                                     </div>
    //                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
    //                                         {/* First Page Button */}
    //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
    //                                             &laquo;
    //                                         </button>
    //                                         {/* Previous Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage - 1)}
    //                                             disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &lt;
    //                                         </button>

    //                                         <button
    //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                                         </button>
    //                                         {/* Next Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage + 1)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &gt;
    //                                         </button>
    //                                         {/* Last Page Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(totalPages)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &raquo;
    //                                         </button>
    //                                     </div>

    //                                 </div>
    //                             </div>
    //                         </div>

    //                     </div>

    //                 </div>
    //             </div>
    //         </div >
    //     </>
    // );
 return (
        <>
            <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                    <div className="col-12">

                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>{t("Budget Estimation List")}</span>
                            </h5>

                            {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}
                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>

                        </div>

                        <div className='col-12 pb-5'>
                            <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                <th style={{ width: "5%" }}>{t("Sr.No")}</th>
                                                <th style={headerStyle}>{t("Approved Year")}</th>
                                                {/* <th style={headerStyle}>Budget ID</th> */}
                                                <th style={headerStyle}>{t("Budget Head")}</th>
                                                <th style={headerStyle}>{t("District")}</th>
                                                <th style={headerStyle}>{t("Taluka")}</th>
                                                <th style={headerStyle}>{t("Work Name")}</th>
                                                <th style={{ width: "15%" }}>{t("Demand Amount")}</th>
                                                <th style={{ width: "15%" }}>{t("Limit Allocated Amount")}</th>
                                                <th style={{ width: "15%" }}>{t("Date")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentBills?.length === 0 ? (
                                                <tr>
                                                    <td colSpan={10} style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (currentBills?.map((budgetEstimation, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                    <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>                                                        <td>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.FinancialYear}</td>
                                                        {/* <td style={{ padding: '8px 8px' }}>{budgetEstimation.BudgetID}</td> */}
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.HeadCode}</td>
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.District}</td>
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.Taluka}</td>
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.ProposalID}</td>
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.DemandAmount}</td>
                                                        <td style={{ padding: '8px 8px' }}>{budgetEstimation.OriginalLimitAllocatedAmount}</td>
                                                        <td style={{ padding: '8px 8px' }}>{new Date(budgetEstimation.Date).toLocaleString()}</td>
                                                    </tr>
                                                );
                                            })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-12 mt-3">
                                    <div className='row'>
                                        <div className='col-6'>
                                            <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                                {t("Showing")} {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {budgetEstimation.length} {t("entries")}
                                            </p>
                                        </div>
                                        <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            {/* First Page Button */}
                                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                                &laquo;
                                            </button>
                                            {/* Previous Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &lt;
                                            </button>

                                            <button
                                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                            </button>
                                            {/* Next Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &gt;
                                            </button>
                                            {/* Last Page Button */}
                                            <button
                                                onClick={() => setCurrentPage(totalPages)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &raquo;
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div >
        </>
    );
};

export default BudgetEstimationList;
